import { type FC } from 'react';
import { Modal } from 'Modal';
import { Text } from 'Text';
import { Button } from 'Button';

/*
    No close button, and onClose navigates away: the student cannot stay on the page.
*/

type Props = {
    reasonTitle: string;
    reasonMessage: string;
    onClose: () => void;
};

export const PrerequisitesNotMetModal: FC<Props> = ({ reasonTitle, reasonMessage, onClose }) => (
    <Modal title={reasonTitle} onClose={onClose} size="sm" hideCloseButton dismissOnOverlayClick={false}>
        <div className="flex flex-col items-center gap-6 px-7.5 pb-10 pt-6">
            <Text as="p" className="text-center text-md text-black">
                {reasonMessage}
            </Text>

            <Button onPress={onClose} color="black">
                {reasonTitle}
            </Button>
        </div>
    </Modal>
);
